import { Button, TableColumnType } from "antd";
import moment from "moment";
import useModals from "../../../../hooks/useModals";
import ReservationDetail from "../../../../model/ReservationDetail";
import DeliveryDetailModal from "../../../../pages/ReservationDetail/components/DeliveryDetailModal";
import { CardTitle, CustomCard } from "./Card.styled";
import { DeliveryStatusTag } from "./DeliveryStatus";
import { CustomTable } from "./Table.styeld";

interface DeliveryInfoProps {
  dataForm?: ReservationDetail;
}

export const DeliveryInfo: React.FC<DeliveryInfoProps> = ({ dataForm }) => {
  const { openModal } = useModals();
  const columns: TableColumnType<any>[] = [
    {
      title: "출고항목 번호",
      dataIndex: "goodsIssueItemNo",
      key: "goodsIssueItemNo",
      render: (value) => value || "-",
    },
    {
      title: "배송타입",
      dataIndex: "deliveryType",
      key: "deliveryType",
      align: "center",
      render: (value) => (
        <div style={{ display: "inline-flex" }}>
          <DeliveryStatusTag value={value} />
        </div>
      ),
    },
    {
      title: "출고의뢰 일시",
      dataIndex: "goodsIssueRequestedAt",
      key: "goodsIssueRequestedAt",
      render: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm") : "-",
    },
    {
      title: "출고완료 일시",
      dataIndex: "goodsIssuedConfirmedAt",
      key: "goodsIssuedConfirmedAt",
      render: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm") : "-",
    },
    { title: "모델명", dataIndex: "goodsIssueModel", key: "goodsIssueModel" },
    {
      title: "상품명",
      dataIndex: "goodsIssueItemName",
      key: "goodsIssueItemName",
    },
    {
      title: "상세",
      dataIndex: "id",
      key: "id",
      align: "center",
      render: (value, record) => {
        const deliveryList = record?.deliveryList;
        const normalValue =
          deliveryList?.find((val: any) => val?.deliveryType === "DELIVERY") ||
          undefined;
        const returnValue =
          deliveryList?.find((val: any) => val?.deliveryType !== "DELIVERY") ||
          undefined;
        return (
          <Button
            disabled={!normalValue && !returnValue}
            type="primary"
            ghost
            size="small"
            onClick={() =>
              openModal(
                <DeliveryDetailModal delivery={returnValue || normalValue} />
              )
            }
          >
            상세
          </Button>
        );
      },
    },
  ];

  return (
    <CustomCard title={<CardTitle>배송현황</CardTitle>}>
      <CustomCard bordered bodyStyle={{ padding: 0 }}>
        <CustomTable
          columns={columns}
          dataSource={dataForm?.goodsIssue?.goodsIssueItems || []}
          pagination={false}
        />
      </CustomCard>
    </CustomCard>
  );
};
